module.exports = __webpack_public_path__ + "img/64.de40352b.jpg";